import { defineMessages } from 'react-intl'

const scope = 'procurify.expense.component.ExpenseLineItemDrawer'

export default defineMessages({
  addDrawerTitle: {
    id: `${scope}.addDrawerTitle`,
    defaultMessage: 'Add expense item',
  },
  editDrawerTitle: {
    id: `${scope}.editDrawerTitle`,
    defaultMessage: 'Edit expense item',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
  createItemButton: {
    id: `${scope}.createItemButton`,
    defaultMessage: 'Create item',
  },
  saveButton: {
    id: `${scope}.saveButton`,
    defaultMessage: 'Save',
  },
  fileNotUploadedToastErrorMessage: {
    id: `${scope}.fileNotUploadedToastErrorMessage`,
    defaultMessage: 'File not uploaded',
  },
})
